import { css } from 'aphrodite'
import PropTypes from 'prop-types'
import { ArrowRight } from 'react-feather'
import { COLOR_TURQUOISE } from '../../lib/colors'

const IconRightArrow = ({ color = COLOR_TURQUOISE, dynamicStyle }) => {
  return <ArrowRight color={color} className={css(dynamicStyle)} />
}

IconRightArrow.propTypes = {
  color: PropTypes.string,
  dynamicStyle: PropTypes.object,
}

export default IconRightArrow
